import React from "react";
// import { v4 as uuid } from "uuid";
import {
  // IconButton,
  MenuItem,
  Menu,
  // Tooltip,
  TextField,
  Button,
  Typography,
  Grid,
  AccordionSummary,
  AccordionDetails,
  AccordionActions,
  Accordion,
  // InputLabel,
} from "@common-ui/ui";
import { useDispatch, useSelector } from "react-redux";
import { AddCircle, ExpandMore } from "@mui/icons-material";
import {
  procedureSlice,
  ITEM_OPTIONS,
} from "../../../../reducers/procedureReducer";
import Instruction from "./Instruction";
import Group from "./Group";
import Custom from "./CustomV2";

import { styled } from "@mui/material/styles";
const StyledAccordionSummary = styled((props) => (
  <AccordionSummary
    // expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
  },
}));

const SubSection = ({
  sectionItem,
  sectionId,
  sectionItemIndex,
  sectionStep,
  step,
  handleRemoveSection,
  expandedChild,
  handleChangeAccordionChild,
}) => {
  const section = useSelector((state) =>
    state.procedure.items.find((section) => section.id === sectionId)
  );
  // const options = ITEM_OPTIONS;
  const [selectedIndex, setSelectedIndex] = React.useState(-1);

  const dispatch = useDispatch();

  const handleClick = (item) => {
    dispatch(
      procedureSlice.actions.addSectionItem({
        sectionId: section.id,
        subSectionId: sectionItem.id,
        name: ITEM_OPTIONS[item],
      })
    );
    // setSubSections([...subSections, { name: options[item], id: uuid() }]);
  };
  const handleRemoveSectionItem = (id) => {
    dispatch(
      procedureSlice.actions.deleteItem({
        sectionId,
        sectionItemId: sectionItem.id,
        type: sectionItem.type,
      })
    );
  };
  const getStep = (id) => {
    return Array.from(section.steps).indexOf(id) + 1;
  };
  return (
    <Accordion
      key={sectionItem.id}
      expanded={expandedChild === sectionItem.id}
      onChange={handleChangeAccordionChild(sectionItem.id)}
    >
      <StyledAccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls={sectionItem.id}
        id={sectionItem.id}
      >
        <Grid container spacing={2}>
          <Grid item md={4} xs={12}>
            {" "}
            <Typography fontWeight="700">
              {`${sectionStep}.${getStep(sectionItem.id)} ${
                String(sectionItem.title).trim() !== ""
                  ? sectionItem.title
                  : "Sub-Section Title"
              }`}
            </Typography>
          </Grid>
          <Grid item md={8} xs={12}>
            <TextField
              sx={{ mt: 0, mr: 0 }}
              size="small"
              onClick={(event) => event.stopPropagation()}
              onFocus={(event) => event.stopPropagation()}
              autoComplete="off"
              fullWidth
              placeholder="Sub-Section Title"
              margin="normal"
              name="type"
              onChange={(e) =>
                dispatch(
                  procedureSlice.actions.setSectionTitle({
                    sectionId: section.id,
                    subSectionId: sectionItem.id,
                    title: e.target.value,
                  })
                )
              }
              value={sectionItem.title}
              // variant="outlined"
            />
          </Grid>
        </Grid>
      </StyledAccordionSummary>
      <AccordionDetails>
        {Array.from(sectionItem.items).map((subSectionItem, index) => {
          return (
            <SectionItem
              key={subSectionItem.id}
              sectionId={sectionId}
              subSectionId={sectionItem.id}
              sectionItem={subSectionItem}
              sectionItemIndex={index}
              sectionStep={sectionStep}
              subSectionStep={getStep(sectionItem.id)}
              step={index + 1}
              handleRemoveSectionItem={handleRemoveSectionItem}
            />
          );
        })}
        <AddNew
          options={ITEM_OPTIONS.filter((v) => v !== "Sub-Section")}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          handleClick={handleClick}
        />
      </AccordionDetails>
      <AccordionActions>
        <Button
          onClick={() => handleRemoveSectionItem()}
          // startIcon={<DeleteForever />}
          size="small"
          sx={{ fontWeight: 200 }}
          color="error"
        >
          Remove
        </Button>
      </AccordionActions>
    </Accordion>
  );
};

const SectionItem = ({
  sectionItem,
  sectionId,
  sectionItemIndex,
  sectionStep,
  step,
  handleRemoveSectionItem,
  expandedChild,
  handleChangeAccordionChild,
  subSectionId,
  subSectionStep,
}) => {
  switch (sectionItem.type) {
    case "INSTRUCTION":
      return (
        <Instruction
          sectionItem={sectionItem}
          sectionId={sectionId}
          subSectionId={subSectionId}
          sectionItemIndex={sectionItemIndex}
          sectionStep={sectionStep}
          subSectionStep={subSectionStep}
          step={step}
          handleRemoveSectionItem={handleRemoveSectionItem}
        />
      );
    case "CUSTOM":
      return (
        <Custom
          sectionItem={sectionItem}
          sectionId={sectionId}
          subSectionId={subSectionId}
          sectionItemIndex={sectionItemIndex}
          sectionStep={sectionStep}
          subSectionStep={subSectionStep}
          step={step}
          handleRemoveSectionItem={handleRemoveSectionItem}
        />
      );
    case "GROUP":
      return (
        <Group
          sectionItem={sectionItem}
          sectionId={sectionId}
          subSectionId={subSectionId}
          sectionItemIndex={sectionItemIndex}
          sectionStep={sectionStep}
          subSectionStep={subSectionStep}
          step={step}
          handleRemoveSectionItem={handleRemoveSectionItem}
        />
      );
    case "SUB-SECTION":
      return (
        <SubSection
          sectionItem={sectionItem}
          sectionId={sectionId}
          subSectionId={subSectionId}
          sectionItemIndex={sectionItemIndex}
          sectionStep={sectionStep}
          subSectionStep={subSectionStep}
          step={step}
          handleRemoveSectionItem={handleRemoveSectionItem}
          expandedChild={expandedChild}
          handleChangeAccordionChild={handleChangeAccordionChild}
        />
      );
    default:
      return "Test";
  }
};

const AddNew = ({
  options,
  selectedIndex,
  //   setSelectedIndex,
  handleClick,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index) => {
    // setSelectedIndex(index);
    handleClick(index);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <p
      style={{
        padding: 16,
        border: "1px dashed #999999",
        // width: "100%",
        borderRadius: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Button
        aria-expanded={open ? "true" : undefined}
        onClick={handleClickListItem}
        startIcon={<AddCircle />}
        sx={{ fontWeight: 200 }}
        size="small"
      >
        Add New
      </Button>
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={option}
            // disabled={index === 0}
            selected={index === selectedIndex}
            onClick={(event) => handleMenuItemClick(event, index)}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </p>
  );
};

const Section = ({
  handleRemoveSection,
  step,
  sectionId,
  expanded,
  handleChangeAccordion,
}) => {
  const section = useSelector((state) =>
    state.procedure.items.find((section) => section.id === sectionId)
  );
  // const options = ITEM_OPTIONS;
  const [selectedIndex, setSelectedIndex] = React.useState(-1);

  const [expandedChild, setExpandedChild] = React.useState(false);

  const handleChangeAccordionChild = (panel) => (event, isExpanded) => {
    setExpandedChild(isExpanded ? panel : false);
  };

  const dispatch = useDispatch();

  const handleClick = (item) => {
    dispatch(
      procedureSlice.actions.addSectionItem({
        sectionId: section.id,
        name: ITEM_OPTIONS[item],
      })
    );
    // setSubSections([...subSections, { name: options[item], id: uuid() }]);
  };
  const handleRemoveSectionItem = (id) => {
    // dispatch(
    //   procedureSlice.actions.removeSectionItem({
    //     sectionId: section.id,
    //     itemId: id,
    //   })
    // );
  };
  return (
    <Accordion
      key={section.id}
      expanded={expanded === section.id}
      onChange={handleChangeAccordion(section.id)}
    >
      <StyledAccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls={section.id}
        id={section.id}
      >
        <Grid container spacing={2}>
          <Grid item md={4} xs={12}>
            {" "}
            <Typography fontWeight="700">
              {`${step} ${
                String(section.title).trim() !== ""
                  ? section.title
                  : "Section Title"
              }`}
            </Typography>
          </Grid>
          <Grid item md={8} xs={12}>
            <TextField
              sx={{ mt: 0, mr: 0 }}
              size="small"
              onClick={(event) => event.stopPropagation()}
              onFocus={(event) => event.stopPropagation()}
              autoComplete="off"
              fullWidth
              placeholder="Section Title"
              margin="normal"
              name="type"
              onChange={(e) =>
                dispatch(
                  procedureSlice.actions.setSectionTitle({
                    sectionId: section.id,
                    title: e.target.value,
                  })
                )
              }
              value={section.title}
              // variant="outlined"
            />
          </Grid>
        </Grid>
      </StyledAccordionSummary>
      <AccordionDetails>
        {Array.from(section.items).map((sectionItem, index) => {
          return (
            <SectionItem
              key={sectionItem.id}
              sectionId={sectionId}
              sectionItem={sectionItem}
              sectionItemIndex={index}
              sectionStep={step}
              step={index + 1}
              handleRemoveSectionItem={handleRemoveSectionItem}
              expandedChild={expandedChild}
              handleChangeAccordionChild={handleChangeAccordionChild}
            />
          );
        })}
        <AddNew
          options={ITEM_OPTIONS}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          handleClick={handleClick}
        />
      </AccordionDetails>
      <AccordionActions>
        <Button
          onClick={() => handleRemoveSection(sectionId)}
          // startIcon={<DeleteForever />}
          size="small"
          sx={{ fontWeight: 200 }}
          color="error"
        >
          Remove
        </Button>
      </AccordionActions>
    </Accordion>
  );
};

export { Section };
